import type { TransferMedication } from 'src/app/hooks/data/prescriptionTransfers';
import type { LoggedInTransferForm } from 'src/app/hooks/feature_data/useLoggedInTransferFormData';
import type { MedicationSearchResult } from 'src/app/types';

export const getMedicationsForTransfer = (transferFormData: LoggedInTransferForm): TransferMedication[] => {
  if (!transferFormData.pharmacyName && !transferFormData.doctorName) return [];
  if (!transferFormData.medications) return [];
  return transferFormData.medications.reduce((acc: TransferMedication[], med: MedicationSearchResult) => {
    if (!med.primaryName) {
      return acc;
    }

    if (!!transferFormData.doctorName) {
      acc.push({
        medicationName: med.primaryName,
        source: 'doctor',
        doctorName: transferFormData.doctorName,
        doctorPhone: transferFormData.doctorPhone,
        pharmacyName: '',
        // hiclSeqno is always a string, but the type definition was lazy and says any "attributes" can be string | bool | null.
        hiclSeqno: med?.hiclSeqno ? med.hiclSeqno.toString() : undefined,
      });
    } else if (!!transferFormData.pharmacyName) {
      if (
        'doctorRequiredForTransfer' in med &&
        med.doctorRequiredForTransfer === false &&
        'eligibleForTransfer' in med &&
        med.eligibleForTransfer === true
      ) {
        acc.push({
          medicationName: med.primaryName,
          source: 'pharmacy',
          pharmacyName: transferFormData.pharmacyName,
          pharmacyDetails: transferFormData.pharmacyAddress,
          pharmacyPhone: transferFormData.pharmacyPhone,
          hiclSeqno: med.hiclSeqno ? med.hiclSeqno.toString() : undefined,
        });
      }
    }
    return acc;
  }, [] as TransferMedication[]);
};
